angular
  .module('app')
  .controller('DashController', DashController);

DashController.$inject = ['$state', 'Session', '$translate'];

function DashController($rootScope, Session, $translate) {
  var vm = this;
  vm.isNavCollapsed = true;
  vm.user = Session;
  vm.langs = [
    'CA',
    'ES',
    'EN'
  ];
  vm.logout = function () {
    Session.destroy();
    Session.go('main.index');
  };

  vm.setLang = function (lng) {
    var id = lng.toLowerCase();
    $translate.use(id);
    // $rootScope.$broadcast('langChange', id);
  };
}
